export enum LineChartName {
	NilePerformance = 'nile-performance',
	IqAnalyticsChart = 'iq-analytics-chart'
}
